import { EventGallery } from '../container';

const EventGalleryPage = () => {
  return (
    <>
      <EventGallery />
    </>
  );
};

export default EventGalleryPage;
